export const APP_ACTION_TYPES = {
    SET_AB_TEST_VARIANT: 'SET_AB_TEST_VARIANT',
    SET_HIDE_DEV_MODE: 'SET_HIDE_DEV_MODE',
    SET_APP_DATA: 'SET_APP_DATA',
    SET_QUIZ_DATA: 'SET_QUIZ_DATA',
    SET_PAGE_CONTENT: 'SET_PAGE_CONTENT',
    SET_UPSELLS_DATA: 'SET_UPSELLS_DATA',
    SET_FEEDBACK_DATA: 'SET_FEEDBACK_DATA',
    SET_COMPONENTS_DATA: 'SET_COMPONENTS_DATA',
    SET_NEW_PAGE_REVIEWS: 'SET_NEW_PAGE_REVIEWS',
    SET_VIDEO_REVIEWS: 'SET_VIDEO_REVIEWS',
    SET_PAYMENT_BUTTONS: 'SET_PAYMENT_BUTTONS',
    SET_OPTION_TEXT_DATA: 'SET_OPTION_TEXT_DATA',
    SET_API_GEO_URL: 'SET_API_GEO_URL',
    SET_REDIRECT_URL: 'SET_REDIRECT_URL',
    SET_EMAIL_PROVIDERS: 'SET_EMAIL_PROVIDERS',
    SET_AB_TEST_CAMPAIGN_NAME: 'SET_AB_TEST_CAMPAIGN_NAME',
    SET_AB_TEST_START_CAMPAIGN_DATE: 'SET_AB_TEST_START_CAMPAIGN_DATE',
    SET_EMAILS_TO_DISABLE_ANALYTICS: 'SET_EMAILS_TO_DISABLE_ANALYTICS',
    SET_QA_TIMER_TIME: 'SET_QA_TIMER_TIME',
    SET_IS_CONFIG_READY: 'SET_IS_CONFIG_READY',
    SET_FLOW_USE_AB_TEST: 'SET_FLOW_USE_AB_TEST',
    SET_ENABLE_UPSELLS: 'SET_ENABLE_UPSELLS',
    SET_PATH_PREFIX: 'SET_PATH_PREFIX',
    SET_MULTIPLE_CONFIG: 'SET_MULTIPLE_CONFIG',
    RESET_STATE: 'RESET_STATE',
    SET_PEOPLE_WAITLIST_DATA: 'SET_PEOPLE_WAITLIST_DATA',

    SET_FLOW_DATA: 'SET_FLOW_DATA',
    SET_ANALYTICS_DATA: 'SET_ANALYTICS_DATA',
    SET_DISCLAIMER_TEXT: 'SET_DISCLAIMER_TEXT',
    SET_DISCLAIMER_ONE_TIME_TEXT: 'SET_DISCLAIMER_ONE_TIME_TEXT'

};

export const appActionCreators = {
    setAbTestVariant: (variant) => ({
        type: APP_ACTION_TYPES.SET_AB_TEST_VARIANT,
        payload: variant
    }),

    setHideDevMode: (hide) => ({
        type: APP_ACTION_TYPES.SET_HIDE_DEV_MODE,
        payload: hide
    }),

    setAppData: (data) => ({
        type: APP_ACTION_TYPES.SET_APP_DATA,
        payload: data
    }),

    setQuizData: (data) => ({
        type: APP_ACTION_TYPES.SET_QUIZ_DATA,
        payload: data
    }),

    setPageContent: (content) => ({
        type: APP_ACTION_TYPES.SET_PAGE_CONTENT,
        payload: content
    }),

    setUpsellsData: (data) => ({
        type: APP_ACTION_TYPES.SET_UPSELLS_DATA,
        payload: data
    }),

    setFeedbackData: (data) => ({
        type: APP_ACTION_TYPES.SET_FEEDBACK_DATA,
        payload: data
    }),

    setComponentsData: (data) => ({
        type: APP_ACTION_TYPES.SET_COMPONENTS_DATA,
        payload: data
    }),

    setNewPageReviews: (reviews) => ({
        type: APP_ACTION_TYPES.SET_NEW_PAGE_REVIEWS,
        payload: reviews
    }),

    setVideoReviews: (reviews) => ({
        type: APP_ACTION_TYPES.SET_VIDEO_REVIEWS,
        payload: reviews
    }),

    setPaymentButtons: (buttons) => ({
        type: APP_ACTION_TYPES.SET_PAYMENT_BUTTONS,
        payload: buttons
    }),

    setOptionTextData: (data) => ({
        type: APP_ACTION_TYPES.SET_OPTION_TEXT_DATA,
        payload: data
    }),

    setApiGeoUrl: (url) => ({
        type: APP_ACTION_TYPES.SET_API_GEO_URL,
        payload: url
    }),

    setRedirectUrl: (url) => ({
        type: APP_ACTION_TYPES.SET_REDIRECT_URL,
        payload: url
    }),

    setEmailProviders: (providers) => ({
        type: APP_ACTION_TYPES.SET_EMAIL_PROVIDERS,
        payload: providers
    }),

    setAbTestCampaignName: (name) => ({
        type: APP_ACTION_TYPES.SET_AB_TEST_CAMPAIGN_NAME,
        payload: name
    }),

    setAbTestStartCampaignDate: (date) => ({
        type: APP_ACTION_TYPES.SET_AB_TEST_START_CAMPAIGN_DATE,
        payload: date
    }),

    setEmailsToDisableAnalytics: (emails) => ({
        type: APP_ACTION_TYPES.SET_EMAILS_TO_DISABLE_ANALYTICS,
        payload: emails
    }),

    setQaTimerTime: (time) => ({
        type: APP_ACTION_TYPES.SET_QA_TIMER_TIME,
        payload: time
    }),

    setIsConfigReady: (ready) => ({
        type: APP_ACTION_TYPES.SET_IS_CONFIG_READY,
        payload: ready
    }),

    setFlowUseAbTest: (flow) => ({
        type: APP_ACTION_TYPES.SET_FLOW_USE_AB_TEST,
        payload: flow
    }),

    setEnableUpsells: (enable) => ({
        type: APP_ACTION_TYPES.SET_ENABLE_UPSELLS,
        payload: enable
    }),

    setPathPrefix: (prefix) => ({
        type: APP_ACTION_TYPES.SET_PATH_PREFIX,
        payload: prefix
    }),

    setMultipleConfig: (config) => ({
        type: APP_ACTION_TYPES.SET_MULTIPLE_CONFIG,
        payload: config
    }),

    resetState: () => ({
        type: APP_ACTION_TYPES.RESET_STATE
    }),

    setPeopleOnWaitlist: (content) => ({
        type: APP_ACTION_TYPES.SET_PEOPLE_WAITLIST_DATA,
        payload: content
    }),

    setFlowData: (data) => ({
        type: APP_ACTION_TYPES.SET_FLOW_DATA,
        payload: data
    }),

    setAnalyticsData: (data) => ({
        type: APP_ACTION_TYPES.SET_ANALYTICS_DATA,
        payload: data
    }),
    setDisclaimerText: (data) => ({
        type: APP_ACTION_TYPES.SET_DISCLAIMER_TEXT,
        payload: data
    }),
    setDisclaimerOneTimeText: (data) => ({
        type: APP_ACTION_TYPES.SET_DISCLAIMER_ONE_TIME_TEXT,
        payload: data
    }),
};